// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1ohL9","range":"MonthRangeSwitch_range__PAeb-","disabled":"MonthRangeSwitch_disabled__26zZw"};